import axios from 'axios';

const state = {
	payments: [],
	// pagamento selezionato dalla lista, usato dal dialog di modifica
	selected: {},
	// elenco ridotto { _id, name, email } dei profili, per il select della creazione manuale
	profiles: [],
};

// NB: niente getter `getSortBy`/`getSortDesc` in questo modulo.
// `paymentmethods.module.js` legge `rootGetters['payments/getSortBy']` (oggi undefined):
// esporli qui cambierebbe il comportamento della lista metodi di pagamento in Impostazioni.
const getters = {
	getPayments: state => {
		return state.payments;
	},
	getSelected: state => {
		return state.selected;
	},
	getProfileOptions: state => {
		return state.profiles;
	},
};

const authHeaders = context => ({
	headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
});

const handleError = (context, err) => {
	if (err.response && err.response.status === 401) {
		context.commit('profile/setLogout', {}, { root: true });
	}
	throw err;
};

const actions = {
	// Lista paginata dei pagamenti (solo SuperAdmin), sezione Gestione > Pagamenti.
	// Ricerca, filtri, ordinamento e paginazione sono lato server: settings = { search, filters, options }
	asyncFetchPayments: (context, settings) => {
		let url = 'payments/all';
		const config = settings || {};
		const filters = config.filters || {};
		const options = config.options || {};
		const params = {
			search: config.search || '',
			page: options.page || 1,
			itemsPerPage: options.itemsPerPage || 25,
			sortBy: (options.sortBy && options.sortBy[0]) || 'created_at',
			sortDesc: !!(options.sortDesc && options.sortDesc[0]),
		};
		if (filters.status) params.status = filters.status;
		if (filters.billingType) params.billingType = filters.billingType;

		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, Object.assign({}, authHeaders(context), { params: params }))
			.then(res => {
				context.commit('setPayments', res.data.data);
				return res.data.pagination;
			})
			.catch(err => handleError(context, err));
	},
	// Elenco ridotto dei profili per il select della creazione manuale
	fetchProfileOptions: context => {
		let url = 'profile/options';
		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, authHeaders(context))
			.then(res => {
				context.commit('setProfileOptions', res.data.data);
				return res.data.data;
			})
			.catch(err => handleError(context, err));
	},
	createPayment: (context, payload) => {
		let url = 'payments/store';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
			.then(res => res.data)
			.catch(err => handleError(context, err));
	},
	updatePayment: (context, payload) => {
		let url = 'payments/update';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
			.then(res => res.data)
			.catch(err => handleError(context, err));
	},
	deletePayment: (context, payload) => {
		let url = 'payments/delete';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
			.then(res => res.data)
			.catch(err => handleError(context, err));
	},
	sendPaymentMail: (context, payload) => {
		let url = 'payments/send-mail';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
			.then(res => res.data)
			.catch(err => handleError(context, err));
	},
	// Esecuzione manuale del ciclo di fatturazione (in produzione lo fa il cron delle 08:00)
	runBilling: context => {
		let url = 'payments/run';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, {}, authHeaders(context))
			.then(res => res.data)
			.catch(err => handleError(context, err));
	},
};

const mutations = {
	setPayments: (state, value) => {
		state.payments = value;
	},
	setSelected: (state, value) => {
		state.selected = value || {};
	},
	setProfileOptions: (state, value) => {
		state.profiles = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
